<template>
    <div class="">
        <PageBreadcrumb :pagetitle="info.title"/>
        <!-- Single Detail -->
        <section class="singlesec py-5">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-lg-9 mb-5 mb-lg-0" v-if="history.nid === '10'">
                        <div class="single-news">
                            <div class="singleimage shrink-effect gradient-full">
                                <img v-bind:src="history.field_basic_image" alt="" class="img-fluid w-100" />
                            </div>
                            <div class="single-title text-center my-4">
                                <h4>{{ history.title }}</h4>
                                <div class="author text-dark font-weight-bold">
                                    <span><i class="fa fa-user-o"></i> {{ history.uid }} on</span>
                                    <span><i class="fa fa-calendar"></i> {{ history.created }}</span>
                                    <span><i class="fa fa-clock-o"></i> {{ history.revision_timestamp }} </span>
                                </div>
                            </div>
                            <div v-html="history.body"></div>
                            <FormContacts />

                        </div>
                    </div>
                    <div class="col-12 col-lg-3">
                        <!-- Start SideBarExtras -->
                        <SideBarExtras />
                        <!-- Start SideBarExtras -->
                        <hr>
                        <!-- Start Latest News Sidebar -->
                        <LatestNews />
                        <!-- End Latest News Sidebar -->
                    </div>
                </div>
            </div>
        </section>
        <!-- End Single Detail -->
    </div>
</template>

<script>
    import PageBreadcrumb from '@/components/PageBreadcrumb';
    import LatestNews from "../components/LatestNews";
    import SideBarExtras from "../components/SideBarExtras";
    import FormContacts from "../components/FormContacts/FormContacts";
    import axios from "axios";

    export default {
        name: 'Copyright',
        data () {
            return {
                info: { title : 'Copyrights' },
                history: null
            }
        },
        components:{
            PageBreadcrumb, LatestNews, SideBarExtras, FormContacts
        },
        mounted () {
            axios
                .get('https://api.fifmi.org.au/api/about')
                .then(result => {
                    for (var i = 0; i < result.data.length; i++) {
                        if(result.data[i].field_domain_access.includes('fifmi') && result.data[i].nid === '10'){
                            this.history = result.data[i];
                        }
                    }
                });
        }
    }
</script>
